/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import "core-js/es6/symbol";
import "core-js/es6/object";
import "core-js/es6/function";
import "core-js/es6/parse-int";
import "core-js/es6/parse-float";
import "core-js/es6/number";
import "core-js/es6/math";
import "core-js/es6/string";
import "core-js/es6/date";
import "core-js/es6/array";
import "core-js/es6/regexp";
import "core-js/es6/map";
import "core-js/es6/set";
import "core-js/es6/promise";

import "core-js/es7/symbol";
import "core-js/es7/object";
import "core-js/es7/math";
import "core-js/es7/string";
import "core-js/es7/array";
import "core-js/es7/map";
import "core-js/es7/set";
import "core-js/es7/promise";
import "core-js/es7/observable";
import "core-js/es7/reflect";
import "core-js/web/dom-collections";
import "core-js/web/immediate";
import "core-js/web/timers";

/** */
import "reflect-metadata";

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
import "classlist.js"; // Run `npm install --save classlist.js`.

/** Evergreen browsers require these. **/
import "core-js/es6/reflect";
import "core-js/es7/reflect";


